export const product_overview =
  'What sector do you operate in? Tell us about your product(s)/ service, production capacity, target market and size.';
export const product_has_fda_approval_or_now_applying =
  'Tell us if your product(s) has received certification (FDA/GSA) or whether you are now applying for or pursuing certification. (Yes/ No/In the Process)';
export const who_are_your_customers =
  'Who are your customers/potential customers? Mention some of them.';
export const who_is_your_competition_and_how_unique_are_you_from_them =
  'Who are your competitors/potential competitors? Mention some of them.';
